import styled from 'styled-components';

import { LANDING_BREAKPOINT } from '@utils/theme/breakPoint';

export const BookerHr = styled.hr`
  width: 100%;
  border-top: unset;
  margin: 0 auto;
  border: 0;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    width: 90%;
    border: 0;
    border-top: 1px solid rgba(41, 42, 44, 0.15);
  }
`;
export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  background-color: white;
  align-items: end;
  gap: 12px;
`;
